import { CSSProperties } from "react";
import { BorderSides } from "../types/merchantConfigTypes";

export const getCardBorderStyles = ({
    borderSides,
    borderWidth,
    borderColor,
}: {
    borderSides?: BorderSides;
    borderWidth?: number;
    borderColor?: string;
}): CSSProperties => {
    if (borderSides === "bottom") {
        return {
            borderBottomWidth: borderWidth,
            borderBottomColor: borderColor,
            borderBottomStyle: "solid",
        };
    }
    return {
        borderWidth,
        borderColor,
        borderStyle: "solid",
    };
};
